import { render, staticRenderFns } from "./AthenaPlanDetail.vue?vue&type=template&id=1b624a87"
import script from "./AthenaPlanDetail.vue?vue&type=script&lang=js"
export * from "./AthenaPlanDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports